import { render } from "./InputSwitch.vue?vue&type=template&id=b0dcb56a"
import script from "./InputSwitch.vue?vue&type=script&lang=js"
export * from "./InputSwitch.vue?vue&type=script&lang=js"

import "./InputSwitch.vue?vue&type=style&index=0&id=b0dcb56a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__